import {
  tourOperatorFrequencyValues,
  tourOperatorReceiveMessageValues,
  tourOperatorTypeValues,
} from '@travel-planner/shared/schemas/operations';
import {
  isCanonicalRecipientPhone,
  normalizeRecipientPhone,
} from '@travel-planner/shared/utils';
import { z } from 'zod';

export const tourOperatorFormSchema = z.object({
  fullName: z.string().min(1, 'Full name is required'),
  type: z.enum(tourOperatorTypeValues),
  receiveMessage: z.enum(tourOperatorReceiveMessageValues),
  companyId: z.uuid('Pick a company'),
  // Same rule as the CRM form and the API. This quick-add surface is where the
  // bare national numbers came from: it shipped a plain text input with no
  // country selector and no validation, so `961481448` stored verbatim and the
  // WhatsApp send boundary later rejected it.
  phone: z
    .string()
    .optional()
    .refine(
      (value) =>
        !value ||
        value.trim() === '' ||
        isCanonicalRecipientPhone(normalizeRecipientPhone(value)),
      {
        message:
          'Include the country code, e.g. +351912345678 — a national number on its own cannot be messaged.',
      }
    ),
  email: z.email('Invalid email').optional(),
  city: z.string().optional(),
  country: z.string().optional(),
  rating: z.number().int().min(1).max(5).optional(),
  frequency: z.enum(tourOperatorFrequencyValues).optional(),
  languages: z.array(z.string()).optional(),
  notes: z.string().optional(),
});

export type TourOperatorFormValues = z.infer<typeof tourOperatorFormSchema>;

export const defaultTourOperatorFormValues: Partial<TourOperatorFormValues> = {
  fullName: '',
  type: 'Driver',
  receiveMessage: 'allowed',
  companyId: '',
  phone: '',
  email: '',
  city: '',
  country: '',
};
